
  export default {
    middleware: ['breadcrumbs', 'jumbotron', 'meta-tags'],
    meta: {
      breadcrumbs: [['i18n/home', '/', 'mobile'], 'i18n/insurance'],
      disableBreadcrumb: true,
      product: 'insurance'
    },
    methods: {
      path (product) {
        if (product === 'mortgage-protection') {
          product += '-insurance';
        } else if (product === 'serious-illness') {
          product += '-cover';
        }
        return this.localePath(`/compare-${product}/`);
      }
    }
  };
